<template>
  <v-dialog persistent v-model="show" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel">
    <v-card>
      <v-card-title class="title">{{ title }}</v-card-title>
      <v-card-text class="body-1" v-show="!!message && !enabledInput">{{ message }}</v-card-text>
      <v-text-field v-show="enabledInput" v-model="input" class="mx-5 mt-3" :label="message" outlined dense></v-text-field>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn @click.native="agree" color="primary" text>{{ $t('common.confirm') }}</v-btn>
        <v-btn v-show="enabledCancelButton" @click.native="cancel" color="primary" text>{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DIALOG_TYPE } from '@/constants';

export default {
  name: 'OwlDialog',
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    input: null,
    options: {
      width: 350,
      zIndex: 200,
      type: DIALOG_TYPE.ALERT,
    },
    error: {},
  }),
  computed: {
    show: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.dialog = value;
        if (value === false) {
          this.cancel();
        }
      },
    },
    enabledCancelButton() {
      return DIALOG_TYPE.ALERT !== this.options.type;
    },
    enabledInput() {
      return DIALOG_TYPE.PROMPT === this.options.type;
    },
  },
  methods: {
    open(title = null, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      if (DIALOG_TYPE.PROMPT === this.options.type) {
        this.resolve(this.input);
      } else {
        this.resolve(true);
      }
      this.dialog = false;
      this.reset();
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
      this.reset();
    },
    reset() {
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>

<style scoped></style>
